import { TFareRuleV2 } from '@/slices/flightData/slices';
import { compareAsc, parse } from 'date-fns';
import { checkIsTet } from './isTet';

const MappingForVCS: { [key: string]: string } = {
  BusinessSmart: '25',
  BusinessFlex: '25',
  EconomySmart: '15',
  EconomyFlex: '15',
  EconomySaver: '15',
};
const isUpdateAllowanceBaggageAmount = (operatingAirline: string, endPoint: string, toPoint: string) => {
  if (operatingAirline === 'QH') {
    if (endPoint === 'VCS' || toPoint === 'VCS') {
      return true;
    }
  }
  return false;
};
export const extractFareRule = ({
  fareRules, checkingDateStr, operatingAirline, endPoint, toPoint, seatClass, cabin,
}: { fareRules: TFareRuleV2[], checkingDateStr: string, operatingAirline: string, endPoint: string, toPoint: string, seatClass: string, cabin: string }) => {
  const checkingDate = parse(checkingDateStr, 'yyyy-MM-dd', new Date());
  const isLunar = checkIsTet(checkingDateStr);
  const filteredFarerules = (fareRules || []).filter((fareRule) => {
    if (operatingAirline === 'QH') {
      return fareRule.operatingAirline === operatingAirline && fareRule.cabin === cabin && fareRule.listClassSameConfig.map((c) => c.toUpperCase()).includes(seatClass.toUpperCase());
    }
    return fareRule.operatingAirline === operatingAirline && fareRule.listClassSameConfig.map((c) => c.toUpperCase()).includes(seatClass.toUpperCase());
  });
  let addon;
  if (isLunar) {
    addon = filteredFarerules.find((fareRule) => fareRule.fromDate === '06/01/2025' && fareRule.toDate === '07/02/2025');
  }

  if (!addon) {
    addon = filteredFarerules.find((fareRule) => (fareRule.fromDate === '0' || compareAsc(parse(fareRule.fromDate, 'dd/MM/yyyy', new Date()), checkingDate) <= 0)
&& (fareRule.toDate === '0' || compareAsc(checkingDate, parse(fareRule.toDate, 'dd/MM/yyyy', new Date())) <= 0));
  }
  if (isUpdateAllowanceBaggageAmount(operatingAirline, endPoint, toPoint) && addon?.cabin && MappingForVCS[addon?.cabin || '']) {
    addon = {
      ...addon,
      allowanceBaggageWeight: MappingForVCS[cabin],
    };
  }
  return addon;
};

export const extractFareRuleSnakeCase = (fareRules: any[], checkingDateStr: string, operatingAirline: string, endPoint: string, toPoint: string) => {
  let checkingDate = parse(checkingDateStr, 'yyyy-MM-dd', new Date());
  if (checkingDate) {
    checkingDate = new Date(checkingDateStr);
  }
  let addon = (fareRules || [])
    .filter((fareRule) => fareRule.operating_airline === operatingAirline)
    .find((fareRule) => (fareRule.from_date === '0' || compareAsc(parse(fareRule.from_date, 'dd/MM/yyyy', new Date()), checkingDate) <= 0)
  && (fareRule.to_date === '0' || compareAsc(checkingDate, parse(fareRule.to_date, 'dd/MM/yyyy', new Date())) <= 0));
  if (isUpdateAllowanceBaggageAmount(operatingAirline, endPoint, toPoint) && addon?.cabin && MappingForVCS[addon?.cabin || '']) {
    const { cabin } = addon;
    addon = {
      ...addon,
      allowance_baggage_weight: MappingForVCS[cabin],
    };
  }
  return addon;
};

export const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

export const camelKeyToSnakeCase = (original: any) => {
  const newObject: any = {};
  // eslint-disable-next-line no-restricted-syntax, guard-for-in
  for (const key in original) {
    newObject[camelToSnakeCase(key)] = original[key];
  }
  return newObject;
};
